import React from 'react'
import { useSuccessSection, SuccessSectionProps } from './useSuccessSection'
import { Link } from 'react-router-dom'
import styles from './SuccessSection.module.scss'

const SuccessSection: React.FC<SuccessSectionProps> = (
  props: SuccessSectionProps
) => {
  const {
    orderId,
    restaurantName,
    whatsappURL,
    whatsappLink,
    isCopied,
    handleCopy,
  } = useSuccessSection(props)

  return (
    <div className={styles.success_container}>
      <div className={styles.success_card}>
        <div className={styles.icon_wrapper}>
          <i className='bi bi-check-circle-fill'></i>
        </div>

        <h2 className={styles.success_title}>Thank You!</h2>
        <p className={styles.success_msg}>
          Your order has been placed successfully and is being prepared.
        </p>

        <div className={styles.order_info}>
          <span>ORDER ID</span>
          <div className={styles.id_wrapper}>
            <strong className={styles.order_number}>{orderId}</strong>
            <button
              className={`${styles.copy_btn} ${isCopied ? styles.copied : ''}`}
              onClick={handleCopy}
              title='Copy Order ID'
            >
              <i className={`bi ${isCopied ? 'bi-check-all' : 'bi-copy'}`}></i>
            </button>
          </div>
        </div>

        <p className={styles.follow_up}>
          We will contact you shortly on your phone number.
        </p>

        <div className={styles.success_actions}>
          {whatsappURL && (
            <a
              href={whatsappLink}
              target='_blank'
              rel='noopener noreferrer'
              className={styles.whatsapp_btn}
            >
              Send to WhatsApp <i className='bi bi-whatsapp ms-2'></i>
            </a>
          )}

          <Link to={`/${restaurantName}`} className={styles.home_btn}>
            Back to Menu <i className='bi bi-house-door ms-2'></i>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default SuccessSection
